import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

// Helper function to format dates for API (convert DD-MM-YYYY to YYYY-MM-DD)
const formatDateForAPI = (dateString) => {
  if (!dateString) return '';
  
  // If date is in DD-MM-YYYY format, convert to YYYY-MM-DD
  if (dateString.includes('-') && dateString.length === 10) {
    const parts = dateString.split('-');
    if (parts.length === 3) {
      const [day, month, year] = parts;
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
  }
  
  return dateString;
};

// Get header statistics (current month)
export const fetchHeaderStats = async () => {
  try {
    const response = await axios.get(`${API_URL}/Dashboard/Header`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });
    
    console.log('Header stats API response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching header stats:', error);
    throw error;
  }
};

// Get product statistics (optional date filter MM-DD-YYYY)
export const fetchProductStats = async (startDate = null, endDate = null) => {
  try {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    const query = params.toString() ? `?${params.toString()}` : '';
    const response = await axios.get(`${API_URL}/Dashboard/Product${query}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });
    
    console.log('Product stats API response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching product stats:', error);
    throw error;
  }
};

// Get country statistics (optional date filter MM-DD-YYYY)
export const fetchCountryStats = async (startDate = null, endDate = null) => {
  try {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    const query = params.toString() ? `?${params.toString()}` : '';
    const response = await axios.get(`${API_URL}/Dashboard/ProductbyCountry${query}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });
    
    console.log('Country stats API response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching country stats:', error);
    throw error;
  }
};

// Get platform statistics by date range - FIXED DATE FORMAT
export const fetchPlatformByDate = async (dateDebut, dateFin) => {
  try {
    if (!dateDebut || !dateFin) {
      throw new Error('Date debut and date fin are required');
    }

    const params = new URLSearchParams();
    params.append('DateDebut', dateDebut);  // MM-DD-YYYY
    params.append('Datefin', dateFin);      // MM-DD-YYYY

    const url = `${API_URL}/Dashboard/PlateformByDate?${params.toString()}`;
    const response = await axios.get(url, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });

    return response.data;
  } catch (error) {
    console.error('❌ Error fetching platform stats:', error);
    throw error;
  }
};

export const fetchProductByPlatform = async (platformId, country = '', dateDebut = '', dateFin = '') => {
  try {
    if (!platformId) {
      throw new Error('Platform ID is required');
    }

    let url = `${API_URL}/Dashboard/ProductbyPlateform/${platformId}`;
    const params = new URLSearchParams();

    // ✅ FIX: Always send MM-DD-YYYY format for API
    const formatToMMDDYYYY = (dateString) => {
      if (!dateString) return '';
      // If already MM-DD-YYYY
      if (dateString.match(/^\d{2}-\d{2}-\d{4}$/)) return dateString;
      // If YYYY-MM-DD (from input)
      if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const [year, month, day] = dateString.split('-');
        return `${month}-${day}-${year}`;
      }
      // Try parsing
      try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '';
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
      } catch {
        return '';
      }
    };

    if (country) params.append('Country', country);
    if (dateDebut) params.append('DateDebut', formatToMMDDYYYY(dateDebut));
    if (dateFin) params.append('Datefin', formatToMMDDYYYY(dateFin));

    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    console.log('Fetching product by platform with URL:', url);

    const response = await axios.get(url, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });

    console.log('Product by platform API response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching product by platform stats:', error);
    throw error;
  }
};



export const fetchProductVariantStats = async (productId, dateDebut, dateFin) => {
  try {
    // ✅ FIX: Send MM-DD-YYYY format directly (do NOT convert to DD/MM/YYYY)
    const apiDateDebut = dateDebut; // Already MM-DD-YYYY from MiniFilter
    const apiDateFin = dateFin;     // Already MM-DD-YYYY from MiniFilter

    const params = new URLSearchParams();
    params.append('DateDebut', apiDateDebut);  // MM-DD-YYYY
    params.append('Datefin', apiDateFin);      // MM-DD-YYYY

    const url = `${API_URL}/Dashboard/StatistiqueByProduit/${productId}?${params.toString()}`;
    console.log('✅ Fetching product variant stats with URL:', url);

    const response = await axios.get(url, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });

    console.log('✅ Product variant stats response:', response.data);
    return response.data;

  } catch (error) {
    console.error('❌ Error fetching product variant stats:', error);
    throw error;
  }
};

// Get country statistics by date range - FIXED DATE FORMAT
export const fetchCountryByDate = async (dateDebut, dateFin) => {
  try {
    if (!dateDebut || !dateFin) {
      throw new Error('Date debut and date fin are required');
    }

    // ✅ FIX: Send MM-DD-YYYY format directly (do NOT convert to DD/MM/YYYY)
    const apiDateDebut = dateDebut; // Already MM-DD-YYYY from MiniFilter
    const apiDateFin = dateFin;     // Already MM-DD-YYYY from MiniFilter

    const params = new URLSearchParams();
    params.append('DateDebut', apiDateDebut);  // MM-DD-YYYY
    params.append('dateFin', apiDateFin);      // MM-DD-YYYY (note: this API uses 'dateFin' not 'Datefin')

    const url = `${API_URL}/Dashboard/ProductbyCountryByDate?${params.toString()}`;
    console.log('✅ Fetching country by date with URL:', url);

    const response = await axios.get(url, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });

    console.log('✅ Country by date API response:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ Error fetching country by date stats:', error);
    throw error;
  }
};

// Get country product statistics - FIXED DATE FORMAT FOR THIS SPECIFIC API
export const fetchCountryProductStats = async (productId, dateDebut, dateFin) => {
  try {
    console.log('🔍 fetchCountryProductStats called with:', { productId, dateDebut, dateFin });
    
    // ✅ FIXED: This API expects MM-DD-YYYY format (keep the original format from MiniFilter)
    const convertToAPIFormat = (mmddyyyy) => {
      if (!mmddyyyy) return '';
      
      // If it's already in MM-DD-YYYY format, just return it as is
      if (mmddyyyy.match(/^\d{2}-\d{2}-\d{4}$/)) {
        return mmddyyyy; // Keep as MM-DD-YYYY format
      }
      
      return mmddyyyy;
    };
    
    const apiDateDebut = convertToAPIFormat(dateDebut);
    const apiDateFin = convertToAPIFormat(dateFin);
    
    console.log('🔄 Converting dates for Country Product API:', {
      original: { dateDebut, dateFin },
      converted: { apiDateDebut, apiDateFin },
      note: 'Using MM-DD-YYYY format'
    });
    
    const params = new URLSearchParams();
    params.append('DateDebut', apiDateDebut);  // Now in MM-DD-YYYY format
    params.append('dateFin', apiDateFin);      // Now in MM-DD-YYYY format
    
    const url = `${API_URL}/Dashboard/ProductbyCountryProduct/${productId}?${params.toString()}`;
    console.log('✅ Fetching country product stats with URL:', url);
    
    const response = await axios.get(url, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });
    
    console.log('✅ Country product stats response:', response.data);
    return response.data;
    
  } catch (error) {
    console.error('❌ Error fetching country product stats:', error);
    console.error('❌ Error details:', {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      url: error.config?.url
    });
    throw error;
  }
};
// Combined dashboard data fetch function
export const fetchDashboardData = async () => {
  try {
    console.log('Fetching complete dashboard data...');
    
    const [headerStats, productStats, countryStats] = await Promise.all([
      fetchHeaderStats(),
      fetchProductStats(),
      fetchCountryStats()
    ]);
    
    return {
      headerStats,
      productStats,
      countryStats
    };
  } catch (error) {
    console.error('Error fetching dashboard data:', error);
    throw error;
  }
};

// Combined filtered dashboard data fetch function
export const fetchFilteredDashboardData = async (filters) => {
  try {
    const { dateDebut, dateFin, country, platformId, productId } = filters;
    
    console.log('Fetching filtered dashboard data with filters:', filters);
    
    const promises = [];
    
    // Always fetch platform data if date range is provided
    if (dateDebut && dateFin) {
      promises.push(fetchPlatformByDate(dateDebut, dateFin));
      promises.push(fetchCountryByDate(dateDebut, dateFin));
    }
    
    // Fetch product by platform data if platform is selected
    if (platformId && dateDebut && dateFin) {
      promises.push(fetchProductByPlatform(platformId, country, dateDebut, dateFin));
    }
    
    // Fetch product variant data if product is selected
    if (productId && dateDebut && dateFin) {
      promises.push(fetchProductVariantStats(productId, dateDebut, dateFin));
      promises.push(fetchCountryProductStats(productId, dateDebut, dateFin));
    }
    
    const results = await Promise.all(promises);
    
    // Map results based on what was requested
    const filteredData = {};
    let resultIndex = 0;
    
    if (dateDebut && dateFin) {
      filteredData.platformStats = results[resultIndex++];
      filteredData.countryByDateStats = results[resultIndex++];
    }
    
    if (platformId && dateDebut && dateFin) {
      filteredData.productByPlatformStats = results[resultIndex++];
    }
    
    if (productId && dateDebut && dateFin) {
      filteredData.productVariantStats = results[resultIndex++];
      filteredData.countryProductStats = results[resultIndex++];
    }
    
    console.log('Filtered dashboard data result:', filteredData);
    return filteredData;
  } catch (error) {
    console.error('Error fetching filtered dashboard data:', error);
    throw error;
  }
};

// Legacy compatibility object (for backward compatibility)
export const dashboardService = {
  getHeaderStats: fetchHeaderStats,
  getProductStats: fetchProductStats,
  getCountryStats: fetchCountryStats,
  getPlatformByDate: fetchPlatformByDate,
  getProductByPlatform: fetchProductByPlatform,
  getProductVariantStats: fetchProductVariantStats,
  getCountryByDate: fetchCountryByDate,
  getCountryProductStats: fetchCountryProductStats,
  getDashboardData: fetchDashboardData,
  getFilteredDashboardData: fetchFilteredDashboardData
};

// Fetch Benefice (profit) data
export const fetchBenefice = async (dateDebut, dateFin, plateformId = null, groupBy = 'day') => {
  try {
    const params = new URLSearchParams();
    params.append('DateDebut', dateDebut);
    params.append('DateFin', dateFin);
    if (plateformId) params.append('PlateformId', plateformId);
    if (groupBy) params.append('groupBy', groupBy);
    const url = `${API_URL}/Dashboard/Benefice?${params.toString()}`;
    const response = await axios.get(url, {
      headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching benefice:', error);
    throw error;
  }
};

// Fetch Benefice by product. Requires plateformId and idProduit.
export const fetchBeneficeByProduct = async (dateDebut, dateFin, plateformId = null, idProduit = null) => {
  try {
    const params = new URLSearchParams();
    params.append('DateDebut', dateDebut);
    params.append('DateFin', dateFin);
    if (plateformId) params.append('PlateformId', plateformId);
    if (idProduit) params.append('Idproduit', idProduit);
    const url = `${API_URL}/Dashboard/Benefice/ByProduct?${params.toString()}`;
    const response = await axios.get(url, {
      headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching benefice by product:', error);
    throw error;
  }
};

// Fetch Charges by type and date
export const fetchChargesByTypeAndDate = async (dateDebut, dateFin, groupBy = 'day') => {
  try {
    const params = new URLSearchParams();
    params.append('DateDebut', dateDebut);
    params.append('DateFin', dateFin);
    params.append('groupBy', groupBy);
    const url = `${API_URL}/Dashboard/ChargesByTypeAndDate?${params.toString()}`;
    const response = await axios.get(url, {
      headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching charges by type:', error);
    throw error;
  }
};

// Fetch header stats with optional date filter
export const fetchHeaderStatsByDate = async (startDate = null, endDate = null) => {
  try {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    const query = params.toString() ? `?${params.toString()}` : '';
    const response = await axios.get(`${API_URL}/Dashboard/Header${query}`, {
      headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching header stats by date:', error);
    throw error;
  }
};

// Fetch stuck orders for a product
export const fetchStuckOrders = async (productId, days = 7) => {
  try {
    const response = await axios.get(`${API_URL}/Dashboard/StuckOrders/${productId}?days=${days}`, {
      headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching stuck orders:', error);
    throw error;
  }
};

// Default export for backward compatibility
export default dashboardService;